import React from "react";

const SitesIdCurrency = ({ row }) => {
  return (
    <div>
      {row.sites.map((s, index) => {
        return (
          <div key={index} style={{ paddingBottom: "10px" }}>
            {s.site?.id}
          </div>
        );
      })}
    </div>
  );
};

export default SitesIdCurrency;
